import React from "react";

import { Form, Input, Select, Button, AutoComplete, Modal, Checkbox,Row,Col } from "antd";
import ReferenceOption from "commons/AllOptions/Reference/index.js";
import ReferenceTableResult from "commons/AllTableList/Reference/index.js";
import ReferenceDetailForm from "commons/AllDetails/Reference/index.js";
import YearPicker from "commons/YearPicker/index";
import centerApis from "src/js/apis/center";

import Utils from "src/js/utils";

import Storage from "src/js/storage";
import Apis from "src/js/apis/api";
import dataApis from "src/js/apis/data";
import "./index.css";
import { withRouter } from "react-router-dom";
const { Option } = Select;
const { TextArea } = Input;

@withRouter
class TaxonomyExtraForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false,
      // reference , taxonomy , section,occurence,formation
      detailData: props.detailData || {},
      onlySeeRef: props.onlySeeRef === true ? true : false,

      name1Opts: [],
      name2Opts: [],
      clatorOpts: [],
      seeOnly: props.seeOnly === true ? true : false,
      treatises: [],
      taxonTypes: [],
      fossilgroup: {},
      allChildError: {},
      isCenterUser: props.isCenterUser === true ? true : false,
      yearValue: null,
      extraData: props.extraData || {},
      extraFlag:false,
      showData_flag:false
    };
  }
  async componentDidMount() {
    let taxonmixed_id;

    if(JSON.stringify(this.state.detailData)!="{}"){
      taxonmixed_id = this.state.detailData.id;
    }else{
      // console.log("extra");
      taxonmixed_id = this.state.extraData.taxonmixed_id
      let params = {
        id:this.state.extraData.taxonmixed_id
      };
      let getTaxonsBack = await Apis.getTaxons(params);
      if (getTaxonsBack.result && getTaxonsBack.result.length > 0) {
        this.setState({
          detailData: getTaxonsBack.result[0] || {}
        });
      }
    }

    let getTaxonsExBack;
    let { isCenterUser } = this.state;
    // let isCenter=(this.props.location.pathname==='/center')
    var userid = Storage.getItem("gbdbid");
    var level = Storage.getItem("gbdblevel");
    let showData=this.state.showData_flag;
    console.log("showData:"+showData);
    
    if(level && level >= 1){
      this.setState({
        showData_flag:true
      });
      showData=true
    }
    if (!showData) {
      let params = {
        "taxonmixed_id":taxonmixed_id
      };
      getTaxonsExBack = await Apis.getTaxonsEx(params);
    } else {
      let params = {
        assetstype: 15,
        // enterer: Storage.getItem("gbdbid"),
        taxonmixed_id
      };
      getTaxonsExBack = await centerApis.searchAssets(params);
    }

    if (getTaxonsExBack.result && getTaxonsExBack.result.length > 0) {
      let extraData=Utils.convertToArray(getTaxonsExBack.result[0]);
      this.setState({
        extraData: extraData || {},
        extraFlag:true
      });
    } else {
      this.setState({
        extraData: {}
      });
      if(getTaxonsExBack.error){
        Modal.error({
          content: getTaxonsExBack.error
        });
      }
    }
  }

  checkTaxonExValue(params){
    let result=true;
    for (var key in params){
      console.log("key:"+key);
      console.log("value:"+params[key]);
      
      if(key!="taxonmixed_id" && key!="fossil_group" && params[key]!=null && params[key]!=""){
        result=false;
        return result;
      }
    }
    return result;
  }

 addTaxonEx = async () => {
  this.props.form.validateFieldsAndScroll(async (err, values) => {
    if (!err) {
      let taxonEx = Utils.filterCondition(values);

      if(this.checkTaxonExValue(taxonEx)){
        Modal.warn({
          content:"Options cannot all be empty!"
        })
      }else{
        taxonEx = Utils.convertToString(taxonEx);

        taxonEx = Utils.addEnterer(taxonEx);
  
        taxonEx = Utils.addAudit(taxonEx);
  
        taxonEx.authState = 0;
        // 服务器注释
        let addTaxonBack = await Apis.addTaxonsEx(taxonEx);
        if (addTaxonBack.error) {
          Modal.error({
            title: "This is an error message",
            content: addTaxonBack.error
          });
        } else if (addTaxonBack.result) {
          if (this.props.addTaxonEx) {
            this.props.addTaxonEx(addTaxonBack.result);
          }
        }
      }
    }
  });
 }
 

  modifyTaxomyEx = async () => {
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        let changeTaxonEx = Utils.filterCondition(values);

        if(this.checkTaxonExValue(changeTaxonEx)){
          Modal.warn({
            content:"Options cannot all be empty!"
          })
        }else{
          changeTaxonEx = Utils.convertToString(changeTaxonEx);

          changeTaxonEx = Utils.addEnterer(changeTaxonEx);
  
          changeTaxonEx = Utils.addAudit(changeTaxonEx);
          let { extraData } = this.state;
          let id = extraData.id;
          changeTaxonEx.id = id;
          changeTaxonEx.authState = 0;
          // 服务器注释
          let changeTaxonBack = await Apis.changeTaxonExById(changeTaxonEx);
          if (changeTaxonBack.error) {
            Modal.error({
              title: "This is an error message",
              content: changeTaxonBack.error
            });
          } else if (changeTaxonBack.result) {
            if (this.props.modifyTaxomyEx) {
              this.props.modifyTaxomyEx(changeTaxonBack.result);
            }
          }
        }
      }
    });
  };

  render() {
    let { getFieldDecorator } = this.props.form;
    let { detailData,extraData, seeOnly, taxonTypes, taxonType,embellish } = this.state;
    let { enterer } = detailData;
    let userid = Storage.getItem("gbdbid") ? Storage.getItem("gbdbid") : "";
    let isClick = true;
    let isCenter = this.props.location.pathname === "/center";
    if (enterer && userid && enterer === userid && isCenter) {
      isClick = true;
    }

    if (isClick === false) {
      getFieldDecorator = (...rest) => {
        return element => {
          let NewElement = React.cloneElement(element, {
            disabled: true
          });
          return this.props.form.getFieldDecorator(...rest)(NewElement);
        };
      };
    }

    let taxonName1 = detailData.taxon_name1;
    let taxonName2 = detailData.taxon_name2;
    let genusPrefix = embellish ? embellish.genusPrefixV : "";
    let spPrefix1 = embellish ? embellish.spPrefix1V : "";
    let spPrefix2 = embellish ? embellish.spPrefix2V : "";
    let spNameDict = embellish ? embellish.spDictV : "";
    let spSuffix = embellish ? embellish.spSuffixV : "";
    let taxonomy_name = Utils.fullName(
      taxonName1,
      taxonName2,
      genusPrefix,
      spPrefix1,
      spPrefix2,
      spNameDict,
      spSuffix
    );

    return (
      <div id="detail_form">
        <div className=" collection-add-main">
          <div className="detailform-title">
            <span className="detailform-name">Taxonomy Functional Traits</span>
          </div>

          <div className="addHigther-main">
            {this.state.extraFlag==true||this.state.showData_flag==true ?(
            <div className="reference-search-form addHigther-form" id="main">
              <Form>
                <div className="referenceSearch-numberProject">
                  <div className="Reference-number">
                    <Form.Item label={<p>Taxon ID</p>}>
                      {getFieldDecorator("taxonmixed_id", {
                        initialValue: detailData.id || null
                      })(<Input disabled></Input>)}
                    </Form.Item>
                  </div>

                  <div className="Reference-number">
                    <Form.Item label={<p>Taxon name</p>}>
                      {getFieldDecorator("fossil_group", {
                        initialValue: taxonomy_name || null
                      })(<Input disabled></Input>)}
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    
                    <Form.Item label={<p>Body size</p>}>
                    <span>                           
                        {getFieldDecorator("body_size", {
                            initialValue: this.state.extraData.body_size || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Large">Large ({`>`}20mm)</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Medium">Medium (5-20mm)</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Small">Small (0.5-5mm)</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Micro">Micro ({`<`}0.5mm)</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Feeding mode</p>}>
                    <span>                           
                        {getFieldDecorator("feeding_mode", {
                            initialValue: this.state.extraData.feeding_mode || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Filter/suspension">Filter/suspension</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Grazer/scraper">Grazer/scraper</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Omnivore">Omnivore</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Predator">Predator</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Scavenger/opportunist">Scavenger/opportunist</Checkbox>
                                  </Col>
                                  <Col span={6}>
                                    <Checkbox value="Sub-surface_deposit_feeder">Sub-surface deposit feeder</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Other">Other</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Mobility</p>}>
                    <span>                           
                        {getFieldDecorator("mobility", {
                            initialValue: this.state.extraData.mobility || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Freely/fast">Freely/fast</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Freely/slow">Freely/slow</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Facultative/unattached">Facultative/unattached</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Facultative/attached">Facultative/attached</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Non-motile/unattached">Non-motile/unattached</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Non-motile/attached">Non-motile/attached</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Morphology</p>}>
                    <span>                           
                        {getFieldDecorator("morphology", {
                            initialValue: this.state.extraData.morphology || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Irregular">Irregular</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Round/Globulose">Round/Globulose</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Streamlined">Streamlined</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Vermiform">Vermiform</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Tiering</p>}>
                    <span>                           
                        {getFieldDecorator("tiering", {
                            initialValue: this.state.extraData.tiering || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Pelagic">Pelagic</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Erect">Erect</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Surficial">Surficial</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Semi-infaunal">Semi-infaunal</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Shallow_infaunal">Shallow infaunal</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Deep_infaunal">Deep infaunal</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Rigidity</p>}>
                    <span>                           
                        {getFieldDecorator("rigidity", {
                            initialValue: this.state.extraData.rigidity || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Hard_exoskeleton">Hard exoskeleton</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Hard_shell">Hard shell</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Rigid/Rigid_tubes">Rigid/Rigid tubes</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Soft/Fragile">Soft/Fragile</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Reproduction</p>}>
                    <span>                           
                        {getFieldDecorator("reproduction", {
                            initialValue: this.state.extraData.reproduction || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Asexual">Asexual</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Sexual">Sexual</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Growth form</p>}>
                    <span>                           
                        {getFieldDecorator("growth_form", {
                            initialValue: this.state.extraData.growth_form || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Solitary">Solitary</Checkbox>
                                  </Col>
                                  <Col span={7}>
                                    <Checkbox value="Multiserial_modularity/coloniality">Multiserial modularity/coloniality</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Structural fragility</p>}>
                    <span>                           
                        {getFieldDecorator("structural_fragility", {
                            initialValue: this.state.extraData.structural_fragility || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={6}>
                                    <Checkbox value="Very_fragile/Highly_breakable">Very fragile/Highly breakable</Checkbox>
                                  </Col>
                                  <Col span={6}>
                                    <Checkbox value="Fragile/Limited_flexibility">Fragile/Limited flexibility</Checkbox>
                                  </Col>
                                  <Col span={6}>
                                    <Checkbox value="Very_strong/Extremely_flexible">Very strong/Extremely flexible</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Larval type</p>}>
                    <span>                           
                        {getFieldDecorator("larval_type", {
                            initialValue: this.state.extraData.larval_type || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Pelagic_planktotrophic">Pelagic planktotrophic</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Pelagic_lecthrotophic">Pelagic lecthrotophic</Checkbox>
                                  </Col>
                                  <Col span={3}>
                                    <Checkbox value="Benthic">Benthic</Checkbox>
                                  </Col>
                                  <Col span={6}>
                                    <Checkbox value="Brooder/Direct_developer">Brooder/Direct developer</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="No_larvae">No larvae</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Trophic level</p>}>
                    <span>                           
                        {getFieldDecorator("trophic_level", {
                            initialValue: this.state.extraData.trophic_level || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Producer">Producer</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="consumer">consumer</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Other">Other</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Sediment stabiliser</p>}>
                    <span>                           
                        {getFieldDecorator("sediment_stabiliser", {
                            initialValue: this.state.extraData.sediment_stabiliser || null
                          })(
                              <Checkbox.Group style={{width:'100%'}}>
                                <Row>
                                  <Col span={5}>
                                    <Checkbox value="Destabiliser">Destabiliser</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="None">None</Checkbox>
                                  </Col>
                                  <Col span={5}>
                                    <Checkbox value="Stabiliser">Stabiliser</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                          )}
                        </span>
                    </Form.Item>
                  </div>
                </div>

                <div className="sectionBase-form">
                  <div className="referenceAdd-title">
                    <Form.Item label={<p>Reference</p>}>
                      {getFieldDecorator("reference", {
                        rules: [{}],
                        initialValue: this.state.extraData.reference || null
                      })(<Input></Input>)}
                    </Form.Item>
                  </div>
                </div>
                
              </Form>
            </div>
            ):
              <div className="tablelist-no-resource">No Resource</div>
            }
          </div>

          {(this.state.extraFlag==true&&this.state.showData_flag==true) ?(
            <div className="referenceSearch-btns sectionBase-btns">
              <div className="formation-complete-btns">
                <Button type="gbdb" onClick={this.modifyTaxomyEx}>
                    <p>Save modify</p>
                </Button>
              </div>
            </div>
          ):null}

          {(this.state.extraFlag==false && this.state.showData_flag==true) ?(
            <div className="referenceSearch-btns sectionBase-btns">
              <div className="formation-complete-btns">
                <Button type="gbdb" onClick={this.addTaxonEx}>
                    <p>Add</p>
                </Button>
              </div>
            </div>
          ):null}
          
        </div>
        <Modal
          destroyOnClose
          visible={this.state.refCondition}
          className="searchResultModal taxResultModal"
          width="76%"
          footer={null}
          header={null}
          onOk={this.handlerefConditionOk}
          onCancel={this.handlerefConditionCancel}
        >
          <ReferenceOption
            childError={this.childError}
            conditions={{}}
            ref="reference"
          ></ReferenceOption>

          {
            <div className="referenceSearch-btns">
              <div>
                <Button
                  type="gbdb"
                  onClick={() => {
                    this.checkAgain("reference");
                  }}
                >
                  <p> Search</p>
                </Button>
              </div>
            </div>
          }
        </Modal>
        
      </div>
    );
  }
}
TaxonomyExtraForm = Form.create({})(TaxonomyExtraForm);
export default TaxonomyExtraForm;
